<template>
    <div v-if="shouldRender" class="element-selector">
        <ListElement v-if="isList" :elData="listData" v-bind="elementProps"></ListElement>
        <ObjectElement v-else-if="isObject" :elData="objectData" v-bind="elementProps"></ObjectElement>
        <ImageElement v-else-if="isImage" :elData="textData" v-bind="elementProps"></ImageElement>
        <InputElement v-else-if="isNotNull" :elData="textData" v-bind="elementProps"></InputElement>
    </div>
</template>

<script>
// Fields only shows if PR-3997-new-purchase-flow flag is enabled
const BLOCKED_KEY_TAILS_WITHOUT_NEW_PURCHASE_FLOW = [
    ['root', 'products', 'productPageVariant'],
    ['root', 'products', 'bestSellerProductId'],
];

function keyTailsEqual(a, b) {
    if (!a || !b || a.length !== b.length) {
        return false;
    }
    return a.join('.') === b.join('.');
}

export default {
    inject: {
        newPurchaseFlowEnabled: {
            from: 'newPurchaseFlowEnabled',
            default: false,
        },
    },
    props: {
        element: Object,
        elData: null,
        keyTail: Array,
        errorInfo: Array,
        onChange: Function,
        retrieveData: Function,
        extraActions: { type: Array, required: false },
    },
    computed: {
        shouldRender() {
            if (this.newPurchaseFlowEnabled) {
                return true;
            }
            return !BLOCKED_KEY_TAILS_WITHOUT_NEW_PURCHASE_FLOW.some((tail) =>
                keyTailsEqual(this.keyTail, tail),
            );
        },
        isList(){
            return this.element.is_list;
        },
        isObject(){
            return this.element.type === 'object';
        },
        isNotNull(){
            return this.element !== null;
        },
        isImage(){
            return this.element.type === 'image';
        },

        elementProps(){
            return {
                element: this.element,
                extraActions: this.extraActions,
                onChange: this.onChange,
                errorInfo: this.errorInfo,
                keyTail: this.keyTail,
                retrieveData: this.retrieveData,
            };
        },

        listData(){
            if(Array.isArray(this.elData))
                return this.elData;

            if(this.elData instanceof Object)
                return [this.elData];

            return [];
        },
        objectData(){
            if(this.elData instanceof Object)
                return this.elData;

            if(Array.isArray(this.elData))
                return this.elData[0];

            return this.elData ? {} : null;
        },
        textData(){
            if(typeof this.elData === 'string')
                return this.elData;

            if(typeof this.elData === 'number')
                return this.elData

            return this.elData ? `${this.elData}` : '';
        }
    },
    components: {
        // Reference: https://vuejs.org/v2/guide/components-edge-cases.html#Circular-References-Between-Components
        ListElement: () => import('./ListElement'),
        ObjectElement: () => import('./ObjectElement'),
        InputElement: () => import('./InputElement'),
        ImageElement: () => import('./ImageElement')
    }
}
</script>

<style>
.element-selector {
    margin-top: 10px;
}
</style>
